import * as api from './index';

export default {
  externalLogin: api.post('/auth/external-login'),
  base: api.post('/auth/login'),
  restore: api.post('/auth/reset-password'),
  newPassword: api.post('/auth/new-password'),
  logout: api.post('/auth/logout'),
}